export const CONFIRMATION_FIELDS = [
    { value: "MY_ROLE", name: "My Role" },
    { value: "CONFIRMATION_ID", name: "Records ID" },
    { value: "TICKER", name: "Ticker" },
    { value: "SECURITY_NAME", name: "Security Name" },
    { value: "ISIN", name: "ISIN" },
    { value: "BBG_TICKER", name: "BBG Ticker" },
    { value: "COUNTRY", name: "Country" },
    { value: "QUANTITY", name: "Quantity" },
    { value: "RATE", name: "Rate" },
    { value: "VALUE", name: "Value" },
    { value: "VALUE_DATE", name: "Value Date" },
    { value: "LOAN_TYPE", name: "Records Type" },
    { value: "STATUS", name: "Status" },
    { value: "CONFIRMED_TIME", name: "Recorded Time" },
    { value: "LAST_UPDATED_TIME", name: "Last Updated Time" },
    { value: "COMMENT", name: "Comment" },
    { value: "CALLABLE", name: "Callable" },
    { value: "DIVIDEND", name: "Dividend" },
    { value: "COLLATERAL_TYPE", name: "Collateral Type" },
    { value: "COLLATERAL_CURRENCY", name: "Collateral Currency" },
    { value: "FR", name: "F/R" },
    { value: "MATURITY_DATE", name: "Maturity Date" },
    { value: "MINIMUM_RETURN_DATE", name: "Minimum Return Date" },
    { value: "SAME_DAY_RETURNABLE", name: "Same Day Returnable" },
    { value: "TERM", name: "Term" },
    { value: "INTERMEDIARY", name: "Intermediary" },
    { value: "INTERMEDIARY_ID", name: "Intermediary Id" },
    { value: "OBJECTIVE", name: "Objective" },
    { value: "TX_TYPE", name: "Type" },
    { value: "MY_ACCOUNT_NAME", name: "My Account Name" },
    { value: "MY_ACCOUNT_CODE", name: "My Account Code" },
    { value: "MY_SLB_NUMBER", name: "My Slb Number" },
    { value: "MY_FUND_CODE", name: "My Fund Code" },
    { value: "MY_CUSTODY_ASSET_TYPE", name: "My Custody Asset Type" },
    { value: "CPTY_NAME", name: "Cpty Name" },
    { value: "CPTY_ACCOUNT_CODE", name: "Cpty Account Code" },
    { value: "CPTY_SLB_NUMBER", name: "Cpty Slb Number" },
    { value: "CPTY_FUND_CODE", name: "Cpty Fund Code" },
    { value: "CPTY_CUSTODY_ASSET_TYPE", name: "Cpty Custody Asset Type" },
    { value: "SETTLEMENT_STATUS", name: "Settlement Status" },
    { value: "SOURCE", name: "Source" },
    { value: "INTERNAL_FUND_CODE", name: "Internal Fund Code" },
    { value: "LIST_NAME", name: "List Name" },
    { value: "ORDER_ID", name: "Ref ID" },
    { value: "CPTY_TRADER_NAME", name: "Cpty User Name" },
    { value: "TRADER", name: "User" },
    { value: "PURPOSE", name: "Purpose" },
];
